import { render, staticRenderFns } from "./MwError.vue?vue&type=template&id=5a6a27dd&"
import script from "./MwError.vue?vue&type=script&lang=js&"
export * from "./MwError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports